export const Colors = {
  Transparent: 'transparent',
  'Base/White': '#FFFFFF',
  'Base/Black': '#121213',
  'Base/LogoPrimary': '#CFF200',
  'Black/Alpha/08': 'rgba(0, 0, 0, 0.08)',
  'Black/Alpha/16': 'rgba(0, 0, 0, 0.16)',
  'Black/Alpha/24': 'rgba(0, 0, 0, 0.24)',
  'Black/Alpha/32': 'rgba(0, 0, 0, 0.32)',
  'Black/Alpha/40': 'rgba(0, 0, 0, 0.40)',
  'Black/Alpha/56': 'rgba(0, 0, 0, 0.56)',
  'Black/Alpha/72': 'rgba(0, 0, 0, 0.72)',
  'Black/Alpha/88': 'rgba(0, 0, 0, 0.88)',
  'White/Alpha/08': 'rgba(255, 255, 255, 0.08)',
  'White/Alpha/16': 'rgba(255, 255, 255, 0.16)',
  'White/Alpha/24': 'rgba(255, 255, 255, 0.24)',
  'White/Alpha/32': 'rgba(255, 255, 255, 0.32)',
  'White/Alpha/40': 'rgba(255, 255, 255, 0.40)',
  'White/Alpha/56': 'rgba(255, 255, 255, 0.56)',
  'White/Alpha/72': 'rgba(255, 255, 255, 0.72)',
  'White/Alpha/88': 'rgba(255, 255, 255, 0.88)',
  'Gray/50': '#F9F9F9',
  'Gray/100': '#F4F4F4',
  'Gray/150': '#E9E9E9',
  'Gray/200': '#DFDFDF',
  'Gray/250': '#D9D9D9',
  'Gray/300': '#BFBFBF',
  'Gray/350': '#B4B4B4',
  'Gray/400': '#AAAAAA',
  'Gray/450': '#9F9F9F',
  'Gray/500': '#7F7F7F',
  'Gray/600': '#6A6A6A',
  'Gray/700': '#555555',
  'Gray/800': '#3F3F3F',
  'Gray/900': '#2A2A2A',
  'Gray/1000': '#151515',
  'Orange/500': '#FF8A00',
  'Blue/500': '#0096D6',
  'Red/400': '#FF3B5C',
  'Samansa_Yellow/50': '#FAFCE6',
  'Samansa_Yellow/100': '#F6F9CC',
  'Samansa_Yellow/200': '#ECF299',
  'Samansa_Yellow/300': '#E3EC66',
  'Samansa_Yellow/400': '#D9E533',
  'Samansa_Yellow/500': '#D0DF00',
  'Samansa_Yellow/600': '#A6B200',
  'Samansa_Yellow/700': '#7D8600',
  'Samansa_Yellow/800': '#535900',
  'Samansa_Yellow/900': '#2A2D00',
  'Samansa_Yellow/Alpha/08': 'rgba(208, 223, 0, 0.08)',
  'Samansa_Yellow/Alpha/16': 'rgba(208, 223, 0, 0.16)',
  'Samansa_Yellow/Alpha/24': 'rgba(208, 223, 0, 0.24)',
  'Samansa_Yellow/Alpha/32': 'rgba(208, 223, 0, 0.32)',
} as const
